






























































import {Component, Prop, Vue} from 'vue-property-decorator';
import {DataTableHeader} from 'vuetify';
import {TableEditType} from '@/enums/table';
import DeleteDialog from '@c/DeleteDialog.vue';
import axios from 'axios';
import Loading from '@c/controls/Loading.vue';
import {PModuleMeasurementActive} from '@/views/system/modules/interfaces';

@Component({
  components: {
    DeleteDialog,
    Loading,
  },
})
export default class TableCheckBox extends Vue {
  @Prop() title!: string;
  @Prop({default: false, type: Boolean}) dense!: boolean;
  @Prop({default: true, type: Boolean}) editable!: boolean;
  @Prop({default: () => []}) headers!: DataTableHeader[];
  @Prop({default: 90}) actionsColumnWidth!: number;
  @Prop({default: false}) customEdit!: boolean;
  @Prop({default: 'id'}) itemKeyName!: string;
  @Prop({default: 'id'}) itemViewKeyName!: string;
  @Prop({default: false}) isChecked!: boolean;
  @Prop({default: false}) hideEditAction!: boolean;

  // Источник данных
  @Prop({required: true}) apiStore!: any;

  loading = false;
  error = false;
  @Prop() editDialog: any;

  get items(): Array<PModuleMeasurementActive> {
    return [...this.apiStore.all];
  }

  // get measurements(): Array<EntityData> {
  //   return [...this.apiStore.entities];
  // }

  getItemKey(item: any) {
    return item[this.itemKeyName];
  }

  get actualHeaders() {
    const actionsSlice = this.editable
      ? [
          {
            text: 'Действия',
            value: 'actions',
            sortable: false,
            width: this.actionsColumnWidth,
          },
        ]
      : [];
    return [...this.headers, ...actionsSlice];
  }

  created() {
    this.getData();
  }

  onCheckBoxChanged() {
    this.$emit('change');
  }

  async getData() {
    this.loading = true;
    this.error = false;
    try {
      await this.apiStore.fetchAll();
    } catch (e) {
      this.error = true;
      console.log(e);
    } finally {
      this.loading = false;
    }
  }

  add() {
    if (!this.customEdit) this.openEditDialog(TableEditType.Add, {id: undefined});
    else this.$emit('add');
  }

  edit(item: any) {
    if (!this.customEdit) this.openEditDialog(TableEditType.Edit, {id: this.getItemKey(item)});
    else this.$emit('edit', item);
  }

  get deleteDialog() {
    return this.$refs.deleteDialog as any;
  }

  deleteItem(item: any) {
    if (!this.customEdit)
      this.deleteDialog.open(this.getItemKey(item), {
        deleteCallback: async (id: string) => {
          try {
            await this.apiStore.delete(id);
            this.getData();
            this.deleteDialog.close();
          } catch (e) {
            this.deleteDialog.error('Произошла ошибка');
          }
        },
      });
    else this.$emit('deleteItem', item);
  }

  // TODO: реализовать в контексте apiStore
  async openEditDialog(actionType: TableEditType, item: any) {
    const {type, title} = this.getInitialParams(actionType);
    const dialog = this.$refs.editDialog as any;
    const options = {
      type,
      title,
      saveCallback: (data: any) => {
        this.save(data, {
          dialog,
        });
      },
    };

    //TODO: CancelToken и axios должен быть в store
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    let request = null;

    if (actionType == TableEditType.Add) request = this.apiStore.create();
    if (actionType == TableEditType.Edit) request = this.apiStore.edit(item.id);

    if (!request) return;

    dialog.openAsync(request, source, options);
  }

  getInitialParams(actionType: TableEditType) {
    let params;
    switch (actionType) {
      case TableEditType.Add:
        params = {
          type: 'add',
          title: 'Создание',
        };
        break;
      case TableEditType.Edit:
        params = {
          type: 'edit',
          title: 'Редактирование',
        };
        break;
    }
    return params;
  }

  handleValidationErrors(detail: any[]) {
    return detail.reduce((obj, err) => {
      const key = err.loc[0] === 'body' ? err.loc[1] : err.loc[0];
      obj[`${key}ValidationError`] = err.msg;
      return obj;
    }, {});
  }

  //TODO: реализовать в контексте apiStore
  async save(
    payload: any,
    //TODO: почему диалог передается в options?
    options: {
      dialog: any;
    },
  ) {
    try {
      await this.apiStore.save(payload);
      this.getData();
      options.dialog.$refs.form.reset();
      options.dialog.close();
      this.$emit('change');
    } catch (e) {
      //TODO надо пилить нормальный обработчик ошибок
      if (e?.response.status === 400) {
        options.dialog.setupErrors(e.response.data.detail);
      } else if (e?.response.status === 422) {
        options.dialog.setupErrors(this.handleValidationErrors(e.response.data.detail));
      } else options.dialog.setupErrors({error: 'Произошла ошибка'});
    }
  }
}
